import { Outlet } from 'react-router-dom';
import "primereact/resources/themes/md-light-indigo/theme.css";     
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";      
import "primeflex/primeflex.css";
import '../../Assets/layout.css' ;
import '../../Assets/primeReact/style.css';
import Footer from './footer';
import Header from './header';

export default function PrimeReactUi () {
    return (
        <div className="main-body">
            <Header />
                <div className='relative h-full'>
                    <div className="flex justify-content-center mt-3">
                        <div className='flex w-11 lg:w-10 justify-content-center'>
                            <div className="grid w-full">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </div>
    )
}